export default `24px  minmax(50px,200px) minmax(50px,360px) 90px 64px 154px 48px minmax(0px,100px) minmax(0px,60px) minmax(0px,60px) minmax(0px,50px)`;
